<template>
  <div class="hc-compact-page hc-schedule-page">
    <div>

      <PageHeader
        :title="`Pendaftaran atau Perjanjian ${clinic_name}`"
        subtitle="Kelola daftar pendaftaran pasien dan perjanjian dokter"
        icon="far fa-calendar-alt"
        action-text="Tambah Perjanjian"
        action-icon="fas fa-plus"
        :show-action="manipulateBtn"
        @action="$router.push('/appointment/add')"
      />

      <div class="row">
        <div class="col-md-12">
          <Card>
            <template v-slot:body>
              <div v-if="loadError" class="appointment-list-alert" role="alert">
                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                <span>{{ loadError }}</span>
                <button type="button" @click="pagination">Coba lagi</button>
              </div>
              <Table
                :items="items"
                :itemExcel="itemExcel"
                :itemPopUp="itemPopUp"
                :fields="fields"
                :perPage="perPage"
                :currentPage="currentPage"
                :totalRows="totalRows"
                :tabFiled="tabFiled"
                :loading="loading"
                :initial-filter="filter"
                show-coverage-filter
                @appointmentOnStatusChange="pagination"
                @filter="generalFilter"
                @filterByPatient="generalFilter"
                @btnDeleteOnClick="btnDeleteOnClick"
                @pageOnClick="pageOnClick"
                @btnExportOnClick="btnExportOnClick" />
            </template>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import module from '@/core/modules/CrudModule.js'
import Table from '@/component/appointments/Table.vue'
import PageHeader from "@/component/general/PageHeader.vue"
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import { getUser } from '@/core/services/jwt.service.js'
import moment from 'moment'

export default {

  components: {
    Card,
    Table,
    PageHeader
  },

  data() {
    return {
      filter: {
        appointment_status_id: '',
        doctor_id: '',
        patient_name: '',
        coverage_type: '',
        start_date: moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end_date: moment().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
      },
      perPage: 15,
      currentPage: 1,
      lastCurrentPage: 1,
      totalRows: 0,
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "display_date",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "time",
          label: "Waktu",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Pasien",
          sortable: true,
        },
        {
          key: "doctor_name_action_type_name",
          label: "Dokter & Jenis Tindakan",
          sortable: true,
        },
        {
          key: "appointment_status_name",
          label: "Status",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],      
      items: [],
      itemExcel: [],
      itemPopUp: [],
      tabFiled: 0,
      loadError: '',
      loading: false,
      requestSequence: 0,
      manipulateBtn: false,
      currentUser: getUser(),
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.lastCurrentPage = page
      this.pagination()
    },

    async pagination() {
      const requestId = ++this.requestSequence
      this.loading = true
      let route
      if (this.currentUser.user_type_id == 1)
        route = `appointments/get-by-doctor/${this.currentUser.id}`
      else
        route = 'appointments'
      let response = await module.paginate(route, this.buildQueryParams())

      // Abaikan respons lama ketika admin mengganti filter dengan cepat.
      if (requestId !== this.requestSequence) return
      this.loading = false

      if (response.error || !response.meta || !response.meta.pagination) {
        this.loadError = 'Data perjanjian belum dapat dimuat. Periksa koneksi lalu coba lagi.'
        return
      }

      this.loadError = ''
      let pagination = response.meta.pagination
      this.totalRows = pagination.total
      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }
      this.items = response.data
    },

    async getExport() {
      let excelRoute, popUpRoute
      if (this.currentUser.user_type_id == 1) {
        excelRoute = `appointment-excel/get-by-doctor/${this.currentUser.id}`
        popUpRoute = `appointment-no-paginations/get-by-doctor/${this.currentUser.id}`
      } else {
        excelRoute = 'appointment-excel'
        popUpRoute = 'appointment-no-paginations'
      }
      const queryParams = this.buildQueryParams()
      let responseExcel = await module.get(excelRoute, queryParams)
      let responsePopUp = await module.get(popUpRoute, queryParams)
      this.itemExcel = responseExcel
      this.itemPopUp = responsePopUp
    },

    buildQueryParams() {
      const params = {
        page: this.currentPage,
        page_size: this.perPage,
        ...this.filter,
      }

      return `?${Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key] == null ? '' : params[key])}`)
        .join('&')}`
    },

    setFilter(sent) {
      for (const key in this.filter) {
        this.filter[key] = sent[key]
      }
      if (
        this.filter.patient_name != '' ||
        this.filter.coverage_type != '' ||
        this.filter.appointment_status_id != '' ||
        this.filter.doctor_id != '' ||
        this.filter.start_date != '' ||
        this.filter.end_date != ''
      )
        this.currentPage = 1
      else
        this.currentPage = this.lastCurrentPage
    },

    async generalFilter(sent) {
      this.setFilter(sent)
      await this.pagination()
    },

    async btnDeleteOnClick(id) {
      let result = await module.delete('appointments/' + id)
      if (result) {
        this.$root.$emit('UpdateNewAppointment')
        this.pagination()
      }
    },

    async btnExportOnClick(filter) {
      this.setFilter(filter)
      await this.getExport()
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)
      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "5002") {
          this.manipulateBtn = true
        }
      }
    },

    async setActiveTab() {
      if (this.$route.params.id == 1) {
        this.tabFiled = 1
        this.filter.appointment_status_id = await 1
        this.pagination()
      } else if (this.$route.params.id == 0) {
        this.pagination()
      }
    }

  },

  mounted() {
    this.setActiveMenu()
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pendaftaran atau Perjanjian" },
      { title: "Semua Pendaftaran atau Perjanjian" },
    ])
    this.setActiveTab()
    this.$root.$on("filterAppointment", (filter) => {
      this.generalFilter(filter)
    })
  }

}
</script>

<style scoped>
.appointment-list-alert {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #f3c7c7;
  border-radius: 12px;
  color: #b4232d;
  background: #fff6f6;
}

.appointment-list-alert button {
  margin-left: auto;
  padding: 0;
  border: 0;
  color: #168e88;
  background: transparent;
  font-weight: 600;
}
</style>

<style lang="scss">
.hc-schedule-header-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #ffffff;
  border: 1px solid #e7edf4;
  border-radius: 16px;
  box-shadow: 0 10px 28px rgba(20, 50, 99, 0.05);
}

.hc-schedule-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  margin-right: 16px !important;
  border-radius: 12px;
  background: rgba(30, 149, 143, 0.08);
  color: #1e958f;
  font-size: 18px;
}

.hc-schedule-header-title {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
  color: #1a2433;
}

.hc-schedule-header-sub {
  font-size: 12px;
  color: #64748b;
}

.hc-btn-tambah-jadwal {
  border-radius: 10px !important;
  min-height: 42px !important;
  padding: 0 22px !important;
  background: linear-gradient(135deg, #14608f, #1e958f) !important;
  border: none !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 14px rgba(30, 149, 143, 0.25) !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;

  i, span {
    color: #ffffff !important;
  }

  &:hover, &:focus, &:active {
    background: linear-gradient(135deg, #0f4c72, #187b76) !important;
    color: #ffffff !important;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(30, 149, 143, 0.35) !important;

    i, span {
      color: #ffffff !important;
    }
  }
}
</style>
